import styled from "styled-components"

export default function PaybackItemBlock({ children }) {
  return (
    <Block>{children}</Block>
  )
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
`;